import { IonIcon, IonItem } from "@ionic/react";
import { formatMessageDate, formatMessageTime } from "../../utils/getDate";
import { getChatUser } from "../Chat/Chat";
import { checkmarkDone } from "ionicons/icons";
import { truncate } from "../../utils/truncate";
import Avatar from "../../components/avatar/Avatar";

const ChatItem = ({ chat, currentProfile, unreadCount }) => {
  const chatUser = getChatUser(chat, currentProfile);
  const lastMessage = chat?.lastMessage || {};
  const media = lastMessage?.media || null;

  if (!chatUser) {
    return null;
  }

  return (
    <div className="chat-row" id="chat-row">
      {/* <img src={chatUser.avatar || "/logo4.png"} alt="avatar" /> */}
      <Avatar
        username={chatUser.username}
        avatar={chatUser.avatar}
        province={chatUser.province}
        isOfficial={chatUser.isAdmin}
        size="large"
      />

      <IonItem
        className="chat-content-container"
        routerLink={`/messages/${chat._id}`}
        detail={false}
      >
        <div className="chat-content">
          <div className="chat-name-date poetsen">
            <h2>
              {truncate(chatUser.fname, 9)} {truncate(chatUser.username, 10)}
            </h2>
          </div>
          <p className="ion-text-wrap">
            {unreadCount > 0 && (
              <IonIcon icon={checkmarkDone} color="primary" />
            )}
            {truncate(chat.lastMessage?.message, 30)}
          </p>
        </div>

        <div className="chat-details">
          <p className={`chat-date ${unreadCount > 0 && "chat-unread"}`}>
            {/* {formatMessageDate(new Date(2024, 1, 1))} */}
            {formatMessageDate(chat.lastMessage?.createdAt)}
          </p>

          {unreadCount > 0 && (
            <div className="chat-notification">{unreadCount}</div>
          )}
        </div>
      </IonItem>
    </div>
  );
};

export default ChatItem;
